export default __webpack_public_path__ + "static/media/information--children-crossing--g5.829b1301.png";